function initSakLooks(root = document) {
  root.querySelectorAll('[data-sak-look]:not([data-ready])').forEach((look) => {
    look.dataset.ready = 'true';
    const list = look.querySelector('.sak-look__list');
    const cards = [...look.querySelectorAll('.sak-look__item')];
    const dots = look.querySelector('.sak-look__dots');
    if (cards.length < 2) return;
    cards.forEach((card, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sak-look__dot';
      dot.setAttribute('aria-label', `Show paired product ${index + 1}`);
      dot.addEventListener('click', () => card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
      dots.append(dot);
    });
    const updateDots = () => {
      const index = Math.round(list.scrollLeft / Math.max(cards[0].getBoundingClientRect().width + 10, 1));
      [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    };
    list.addEventListener('scroll', updateDots, { passive: true });
    updateDots();
  });
}
document.addEventListener('DOMContentLoaded', () => initSakLooks());
document.addEventListener('shopify:section:load', (event) => initSakLooks(event.target));
